<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-row gutter="3">
			<nk-col
				v-for="(flurstueck, indexFlurstuecke) in context.flurstuecke"
				:key="`flist${indexFlurstuecke}`"
				md="6/12"
				lg="4/12"
			>
				<nk-card>
					<template #body>
						<vue-easy-lightbox
							:visible="visibleImage === flurstueck.id"
							:imgs="[
								{
									src: flurstueck.bild,
									title: flurstueck.titel,
									alt: `${flurstueck.einleitung} ${flurstueck.text}`,
								},
							]"
							:index="flurstueck.id"
							@hide="visibleImage = null"
						/>
						<!-- Advanced Description -->
						<component
							:is="flurstueck.bild ? 'a' : 'span'"
							:href="flurstueck.bild || null"
							@click.prevent="visibleImage = flurstueck.id"
						>
							<nk-title size="md" no-margin>
								{{ flurstueck.titel }}
							</nk-title>
						</component>
						<nk-list variant="clean">
							<nk-list-item
								v-if="
									flurstueck.adresse.strasse ||
									flurstueck.adresse.plz ||
									flurstueck.adresse.ort
								"
							>
								<nk-address
									:strasse="
										flurstueck.adresse.strasse
											? flurstueck.adresse.strasse
											: null
									"
									:plz="flurstueck.adresse.plz ? flurstueck.adresse.plz : null"
									:ort="flurstueck.adresse.ort ? flurstueck.adresse.ort : null"
									:geokoordinaten="
										flurstueck.adresse.geokoordinaten
											? flurstueck.adresse.geokoordinaten
											: null
									"
								/>
							</nk-list-item>
							<nk-list-item v-if="flurstueck.zahlen.quadratmeter">
								<span>Quadratmeter:&nbsp;</span>
								<strong>
									{{ flurstueck.zahlen.quadratmeter }} m
									<sup>2</sup>
								</strong>
							</nk-list-item>
							<nk-list-item v-if="flurstueck.zahlen.preis_pro_quadratmeter">
								<span>Preis pro Quadratmeter:&nbsp;</span>
								<strong>
									{{
										flurstueck.zahlen.preis_pro_quadratmeter.toLocaleString(
											'de-DE',
											{
												style: 'currency',
												currency: 'EUR',
											},
										)
									}}
								</strong>
							</nk-list-item>
							<nk-list-item v-if="flurstueck.zahlen.preis_gesamt">
								<span>Preis gesamt:&nbsp;</span>
								<strong>
									{{
										flurstueck.zahlen.preis_gesamt.toLocaleString('de-DE', {
											style: 'currency',
											currency: 'EUR',
										})
									}}
								</strong>
							</nk-list-item>
							<template v-if="flurstueck.dokumente.length">
								<nk-list-item
									v-for="(
										dokument, indexFlurstueckDokumente
									) in flurstueck.dokumente"
									:key="`indexFlurstueckDokumente${indexFlurstueckDokumente}`"
									icon="download"
								>
									<a
										:href="dokument.link"
										:aria-label="`Dokument ${dokument.downloadtext} öffnet in einem neuen Tab`"
										target="_blank"
									>
										{{ dokument.downloadtext }}
									</a>
								</nk-list-item>
							</template>
						</nk-list>
					</template>
				</nk-card>
			</nk-col>
		</nk-row>
	</nk-wrapper>
</template>

<script>
import {ref} from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateBaugebieteFlurstuecke',
	components: {VueEasyLightbox},
	mixins: [TemplatesDefault],
	setup() {
		const visibleImage = ref(null);
		return {visibleImage};
	},
};
</script>

<style>
.gslide-image img {
  min-height: 500px;
}
</style>
